import { INFINITE_SCROLL_WINDOW_INDEX } from './../../util/common';
import { ErrorMessage, ErrorState } from '@jfs/network'
import { hyphenSplashSeparatedDate } from '@jfs/utils'
import { flow, types } from 'mobx-state-tree'
import { Config } from 'react-native-config'
import { checkPaymentStatus } from '../../network/checkPaymentStatus'
import { createOrder, redirectPgFn } from '../../network/createOrder'
import { fetchBillerCategoriesV2 } from '../../network/fetchBillerCategoriesV2'
import { getAuthenticatorList } from '../../network/getAuthenticatorList'
import { getBillFetch, returnExtraInfo } from '../../network/getBillfetch'
import { getDueBillList } from '../../network/getDueBillList'
import { getFavouriteTransaction } from '../../network/getFavouriteTransaction'
import { getLocationList } from '../../network/getLocationList'
import { getOperatorList } from '../../network/getOperatorList'
import { getOrderHistory, searchByOrderId } from '../../network/getOrderHistory'
import { registerBillerAPI } from '../../network/registerBillerAPI'
import { seachBillers } from '../../network/seachBillers'
import { searchAgent } from '../../network/searchMerchant'
import {
  TransactionStatus,
  getCategoryMetaData,
  getDateInfo,
  getNoticeInfo,
  getStatusFromOrderApi,
  simpleDateFormat,
} from '../../util/billPaymentUtil'
import { Colors, getBillPayErrorMessage, getSelectedDate } from '../../util/util'
import { RootStore } from '../store'

const FieldAuthenticator = types.model('FieldAuthenticator', {
  id: types.optional(types.string, ''),
  displayName: types.optional(types.string, ''),
  dataType: types.optional(types.string, ''),
  fieldErrorMessage: types.optional(types.string, ''),
  fieldValidationPattern: types.optional(types.string, ''),
  enabled: types.optional(types.string, ''),
})

const Nickname = types.model('Nickname', {
  id: types.optional(types.number, 0),
  nickNameSuggestions: types.maybeNull(types.optional(types.array(types.string), [])),
  nickNameValidationPattern: types.optional(types.string, ''),
  nickNameValidationMessage: types.optional(types.string, ''),
})

const Operator = types.model('Operator', {
  id: types.number,
  autoPayAllow: types.optional(types.boolean, false),
  categoryId: types.optional(types.number, 0),
  logoPath: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  shortName: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  isBbps: types.optional(types.boolean, false),
  maxAmount: types.optional(types.string, '10000'),
  minAmount: types.optional(types.string, '1'),
  searchTags: types.maybeNull(types.optional(types.string, '')),
  partialPaymentAllow: types.optional(types.boolean, false),
  partialPaymentType: types.optional(types.string, ''),
  billFetchAllow: types.optional(types.boolean, false),
  isExistingBiller: types.optional(types.boolean, false),
  fields: types.optional(types.array(FieldAuthenticator), []),
  iDEBPP: types.maybeNull(types.optional(types.number, 0)),
  // distributor: types.optional(types.array(Distributor), []),
  nickNameField: types.optional(Nickname, {}),
  amountLov: types.maybeNull(types.optional(types.string, '')),
})

const BillerCategory = types.model('BillerCategory', {
  id: types.number,
  name: types.optional(types.string, ''),
  displayName: types.optional(types.string, ''),
  status: types.optional(types.string, 'Active'),
})

const CategoryGroup = types.model('CategoryGroup', {
  categoryList: types.optional(types.array(BillerCategory), []),
  categoryType: types.optional(types.string, ''),
})

const PaymentConfig = types.model('PaymentConfig', {
  id: types.optional(types.string, ''),
  ccUrl: types.optional(types.string, ''),
  returnUrl: types.optional(types.string, ''),
  netbankingUrl: types.optional(types.string, ''),
  clientId: types.optional(types.string, ''),
  checksum: types.optional(types.string, ''),
})
const ExtraInfo = types.model('ExtraInfo', {
  id: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
})
const history = types.model('History', {
  id: types.optional(types.string, ''),
  nickName: types.optional(types.string, ''),
  auth1: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  paymentDate: types.maybeNull(types.optional(types.string, '')),
  paymentAmount: types.maybeNull(types.optional(types.string, '')),
  billerRefNo: types.maybeNull(types.optional(types.string, '')),
  bbpsRegNo: types.maybeNull(types.optional(types.string, '')),
  rrn: types.maybeNull(types.optional(types.string, '')),
  billdate: types.maybeNull(types.optional(types.string, '')),
  billDueDate: types.maybeNull(types.optional(types.string, '')),
  billAmount: types.maybeNull(types.optional(types.string, '')),
  billerId: types.optional(types.number, 0),
})

const Bill = types.model('Bill', {
  id: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  agentFeeAmount: types.optional(types.string, ''),
  billerShortName: types.optional(types.string, ''),
  operatorId: types.optional(types.number, 0),
  operatorName: types.optional(types.string, ''),
  categoryId: types.optional(types.number, 0),
  amountAfterDueDate: types.optional(types.string, ''),
  date: types.optional(types.string, ''),
  dueDate: types.optional(types.string, ''),
  billNumber: types.optional(types.string, ''),
  authenticators: types.optional(types.array(types.string), ['']),
  labelOfAuthenticators: types.array(types.string),
  status: types.maybeNull(types.optional(types.string, '')),
  customerBillDataId: types.optional(types.number || types.string, 0),
  customerBillerAccountId: types.maybeNull(types.optional(types.number, 0)),
  shortName: types.optional(types.string, ''),
  ebppBillerMasterId: types.optional(types.number || types.string, 0),
  alertFlag: types.optional(types.boolean, false),
  alertMessage: types.optional(types.string, ''),
  proceedPaymentFlag: types.optional(types.boolean, false),
  proceedPaymentAlertMsg: types.optional(types.string, ''),
  physicalBillUrl: types.optional(types.string, ''),
  existingBillerFlag: types.optional(types.boolean, false),
  extraInfos: types.array(ExtraInfo),
  period: types.optional(types.string, ''),
  siStatus: types.optional(types.boolean, false),
  siMaxLimit: types.optional(types.string, ''),
  payDaysBefore: types.maybeNull(types.optional(types.string, '-1')),
  customerName: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  scheduledDebitDate: types.optional(types.string, ''),
  lastPaymentGreaterThanBillCreatedDate: types.maybeNull(types.optional(types.boolean, false)),
  createdDate: types.optional(types.string, ''),
  lastPaidDate: types.optional(types.string, ''),
  circleId: types.optional(types.number, 0),
  circleName: types.optional(types.string, ''),
  billPresentConsent: types.optional(types.boolean, false),
  billPresentConsentDisplay: types.optional(types.boolean, false),
  lastTxnRefNo: types.optional(types.string, ''),
  customerAccountId: types.optional(types.number, 0),
  partnerCode: types.optional(types.string, ''),
  partialPaymentAllow: types.optional(types.boolean, false),
  history: types.array(history),
  beneficiaryId: types.optional(types.number, 0),
  customerMobileNumber: types.optional(types.string, ''),
  customerModeOfPayment: types.optional(types.string, ''),
})

const SubMerchant = types.model('SubMerchant', {
  mid: types.optional(types.string, ''),
  terminalId: types.optional(types.string, ''),
  clientId: types.optional(types.string, ''),
  checksum: types.optional(types.string, ''),
  merchantVPA: types.maybeNull(types.optional(types.string, '')),
})

const Merchant = types.model('Merchant', {
  mid: types.optional(types.string, ''),
  terminalId: types.optional(types.string, ''),
  clientId: types.optional(types.string, ''),
  checksum: types.optional(types.string, ''),
  subMerchant: types.optional(SubMerchant, {}),
  merchantVPA: types.maybeNull(types.optional(types.string, '')),
})

const TxnMetaData = types.model('TxnMetaData', {
  id: types.optional(types.number, 0),
  orderId: types.optional(types.string, ''),
  catId: types.optional(types.number, 100006),
  category: types.optional(types.string, ''),
  bill: types.optional(Bill, {}),
  txnRefNo: types.optional(types.string, ''),
  myjioToken: types.optional(types.string, ''),
  paymentMode: types.optional(types.string, ''),
  displayName: types.optional(types.string, ''),
  bbpsRefNo: types.optional(types.string, ''),
  merchant: types.optional(Merchant, {}),
  moduleName: types.optional(types.string, 'PMB'),
  screenName: types.optional(types.string, 'Category'),
  pgToken: types.optional(types.string, ''),
  pgUrl: types.optional(types.string, 'https://www.google.com/'),
  status: types.maybeNull(types.optional(types.string, '')),
  message: types.maybeNull(types.optional(types.string, '')),
  myJioTxnNo: types.optional(types.string, ''),
  myJioUtrNo: types.optional(types.string, ''),
  errorMessage: types.optional(types.string, ''),
})

const Wallet = types.model('Wallet', {
  name: types.optional(types.string, ''),
  balance: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  accountName: types.optional(types.string, ''),
  vpa: types.optional(types.string, ''),
})

const Bank = types.model('Bank', {
  id: types.optional(types.string, ''),
  bankName: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  isPopular: types.optional(types.boolean, false),
  rank: types.optional(types.number, 0),
})
const BankAccount = types.model('BankAccount', {
  id: types.optional(types.string, ''),
  bank: types.optional(Bank, {}),
  type: types.optional(types.string, ''),
  ifsc: types.optional(types.string, ''),
  accountNumber: types.optional(types.string, ''),
  accountName: types.optional(types.string, ''),
})

const UPIPull = types.model('UPIPull', {
  id: types.optional(types.string, ''),
  accountName: types.optional(types.string, ''),
  vpa: types.optional(types.string, ''),
})

const UPI = types.model('UPI', {
  id: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  vpa: types.optional(types.string, ''),
  account: types.optional(BankAccount, {}),
})
const Card = types.model('Card', {
  id: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  cardNumber: types.optional(types.string, ''),
  expiry: types.optional(types.string, ''),
  holderName: types.optional(types.string, ''),
  issuer: types.optional(types.string, ''),
  issuerLogo: types.optional(types.string, ''),
  cvv: types.optional(types.string, ''),
})

const Distributor = types.model('Distributor', {
  id: types.optional(types.number, 0),
  apiPath: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
})

const FieldDetails = types.model('FieldDetails', {
  id: types.optional(types.number, 0),
  displayName: types.optional(types.string, ''),
  fieldErrorMessage: types.optional(types.string, ''),
  dataType: types.optional(types.string, ''),
})

const StateDetail = types.model('StateDetail', {
  id: types.optional(types.number, 0),
  name: types.optional(types.string, ''),
  city: types.optional(types.array(types.string), []),
  // city: types.optional(types.string, ''),
  fieldDetails: types.optional(types.array(FieldDetails), []),
})
const SelectedLocation = types.model('SelectedLocation', {
  state: types.optional(types.string, ''),
  city: types.optional(types.string, ''),
})

const LocationList = types.model('LocationList', {
  id: types.optional(types.number, 0),
  fieldDetails: types.optional(types.array(FieldDetails), []),
  selectedLocation: types.optional(SelectedLocation, {}),
  state: types.optional(types.array(StateDetail), []),
})
const Transaction = types.model('Transaction', {
  id: types.optional(types.string, ''),
  orderId: types.optional(types.string, ''),
  invoiceNumber: types.optional(types.string, ''),
  status: types.optional(types.string, 'RECHECK'),
  timeStamp: types.optional(types.string, ''),
  message: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  paymentModes: types.array(types.union(Wallet, Card, UPI, Bank, UPIPull)),
  paymentConfig: types.array(PaymentConfig),
  txnId: types.optional(types.string, ''),
  txnMetaData: types.optional(TxnMetaData, {}),
  distributor: types.optional(types.array(Distributor), []),
  locationInfo: types.optional(LocationList, {}),
  currentNewsPageStarted: types.optional(types.number, 0),
  currentNewsPageFetched: types.optional(types.number, 0),
})

const Plan = types.model('Plan', {
  id: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  talktime: types.optional(types.string, ''),
  validity: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
})

const Circle = types.model('Circle', {
  billerMasterId: (types.number, 0),
  id: (types.number, 0),
  circleName: types.optional(types.string, ''),
  plans: types.optional(types.array(Plan), []),
})

const Address = types.model('Address', {
  registeredAddress: types.optional(types.string, ''),
  registeredState: types.optional(types.string, ''),
  registeredCity: types.optional(types.string, ''),
  registeredCountry: types.optional(types.string, ''),
  registeredPinCode: types.optional(types.string, ''),
  latitude: types.optional(types.string, ''),
  longitude: types.optional(types.string, ''),
})

const User = types.model('User', {
  id: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  shopName: types.optional(types.string, ''),
  businessType: types.optional(types.string, ''),
  address: types.optional(Address, {}),
  firstName: types.optional(types.string, ''),
  lastName: types.optional(types.string, ''),
  mobile: types.optional(types.string, ''),
  email: types.optional(types.string, ''),
  favourites: types.array(Bill),
  bills: types.array(Bill),
  isJpb: types.optional(types.boolean, true),
  disableBillPayment: types.optional(types.boolean, true),
  sFromCategory: types.optional(types.boolean, false),
})

const Beneficiary = types.model('beneficiary', {
  id: types.optional(types.number, 0),
})

const Fulfilment = types.model('fulfilment', {
  status: types.optional(types.string, ''),
})
const PartnerConfig = types.model('partnerConfig', {
  timeOutFlag: types.optional(types.string, ''),
  errorFlag: types.optional(types.string, ''),
})

const Account = types.model('Account', {
  vpa: types.optional(types.string, ''),
})

const AmountDetails = types.model('AmountDetails', {
  netAmount: types.optional(types.string, ''),
})
const Payment = types.model('payment', {
  account: types.optional(Account, {}),
  agentFeeAmount: types.optional(types.string, ''),
  amountDetails: types.optional(AmountDetails, {}),
  chargeAmount: types.optional(types.string, ''),
  id: types.optional(types.string, ''),
  paymentAt: types.optional(types.string, ''),
  paymentInstrument: types.optional(types.string, ''),
  paymentProcessorRefNo: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
})

const Product = types.model('Product', {
  bbpsRegNo: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
})
const Order = types.model('order', {
  id: types.optional(types.string, ''),
  beneficiary: types.optional(Beneficiary, {}),
  fulfilment: types.optional(Fulfilment, {}),
  index: types.optional(types.number, -1),
  logoPath: types.optional(types.string, ''),
  partnerConfig: types.optional(PartnerConfig, {}),
  payment: types.optional(Payment, {}),
  product: types.optional(Product, {}),
  status: types.optional(types.string, ''),
})

const DateRange = types.model('date', {
  fromDate: types.optional(types.union(types.Date, types.null, types.string), null),
  toDate: types.optional(types.union(types.Date, types.null, types.string), null),
  dateLabel: types.optional(types.string, ''),
})

export const Filters = types.model('Filters', {
  mobile: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  invoiceNo: types.optional(types.string, ''),
  email: types.optional(types.string, ''),
  paymentLinkStatus: types.optional(types.string, ''),
  selectedDateInfo: types.optional(DateRange, {}),
})

const BillPayments = types
  .model('BillPayments', {
    user: User,
    operator: types.optional(types.array(Operator), []),
    utilityCategory: types.optional(types.array(BillerCategory), []),
    rechargeCategory: types.optional(types.array(BillerCategory), []),
    subscriptionCategory: types.optional(types.array(BillerCategory), []),
    otherCategory: types.optional(types.array(BillerCategory), []),
    financialServices: types.optional(types.array(BillerCategory), []),
    category: types.optional(types.array(CategoryGroup), []),
    transaction: types.optional(Transaction, {}),
    circle: types.optional(types.array(Circle), []),
    jTokenId: types.optional(types.string, ''),
    orders: types.optional(types.array(Order), []),
    selectedDateInfo: types.optional(DateRange, {}),
    filter: Filters,
  })
  .actions((self) => ({
    updateUserDetails: (params: any) => {
      const own = self
      own.user.firstName = params?.firstName ?? own.user.firstName
      own.user.lastName = params?.lastName ?? own.user.lastName
      own.user.name = params?.name ?? own.user.name
      own.user.shopName = params?.shopName ?? own.user.shopName
      own.user.businessType = params?.businessType ?? own.user.businessType
      own.user.address = params?.address ?? own.user.address
      own.user.mobile = params?.mobile ?? own.user.mobile
      own.user.email = params?.email ?? own.user.email
      own.user.id = params?.id ?? own.user.id
      own.user.disableBillPayment = params?.disableBillPayment ?? own.user.disableBillPayment
    },
    getCategoryApiV2: flow(function* getCategoryApiV2() {
      try {
        const own = self
        const result = yield fetchBillerCategoriesV2(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
        )
        const { response, category }: any = result ?? {}
        //const categoryResponse: any = [...self?.utilityCategory, ...response]
        own.utilityCategory = response?.Utilities ?? []
        own.financialServices = response?.Finances ?? []
        own.otherCategory = response?.Others ?? []
        own.rechargeCategory = response?.Recharge ?? []
        own.category = category ?? []
        return response
      } catch (error) {
        RootStore?.response?.setMessage(getBillPayErrorMessage(error)?.message)
        console.log('error', error)
        throw error
      }
    }),
    getCategoryList: () => {
      const own = self
      let category = JSON.parse(JSON.stringify(own.category))
      if (category?.length) {
        const finalCategories = []
        category.map((item: any) => {
          const activeCategories = []
          item?.categoryList?.map((elem: any) => {
            if (elem?.status === 'Active') {
              activeCategories.push({
                ...elem,
                iconId: getCategoryMetaData(elem?.id).icon,
              })
            }
          })
          finalCategories.push({
            ...item,
            categoryList: activeCategories,
          })
        })
        category = finalCategories.reverse()
      }
      return category ?? []
    },
    getAllCatogories: () => {
      const own = self
      const otherCategory = []
      own?.otherCategory?.map((item: any) => {
        if (item.status === 'Active') {
          otherCategory.push({
            id: item?.id ?? 0,
            name: item?.name ?? '',
            iconId: getCategoryMetaData(item?.id).icon,
          })
        }
      })
      const utilityCategory = []
      own?.utilityCategory?.map((item: any) => {
        if (item.status === 'Active') {
          utilityCategory.push({
            id: item?.id ?? 0,
            name: item?.name ?? '',
            iconId: getCategoryMetaData(item?.id).icon,
          })
        }
      })
      const rechargeCategory = []
      own?.rechargeCategory?.map((item: any) => {
        if (item.status === 'Active') {
          rechargeCategory.push({
            id: item?.id ?? 0,
            name: item?.name ?? '',
            iconId: getCategoryMetaData(item?.id).icon,
          })
        }
      })
      const financialServices = []
      own?.financialServices?.map((item: any) => {
        if (item.status === 'Active') {
          financialServices.push({
            id: item?.id ?? 0,
            name: item?.name ?? '',
            iconId: getCategoryMetaData(item?.id).icon,
          })
        }
      })
      return {
        otherCategory: otherCategory,
        utilityCategory: utilityCategory,
        rechargeCategory: rechargeCategory,
        financialServices: financialServices,
      }
    },
    getDueBillListApi: flow(function* getDueBillListApi() {
      try {
        const own = self
        const { operatorList, billList, errorData } = yield getDueBillList(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
        )
        if (errorData && errorData?.error) {
          //self.message.setMessage(errorData?.error.message, MessageTypes.errorAlert, true)
          return errorData
        } else {
          const mergedOperators: any = [...own.operator, ...operatorList]
          own.user.bills = billList
          own.operator = mergedOperators
        }
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        // self.message.setMessage(message, MessageTypes.errorAlert, true)
        throw customError
      }
    }),
    updateBillfetchMetaData: (params: any) => {
      console.log('******* update tansaction called => params: ', params)
      try {
        const own = self
        let id: any = '9988'
        const transaction = own.transaction
        if (params?.authenticators && params?.authenticators?.length > 0) {
          const [currentFirstAuth] = params?.authenticators
          const [prevFirstAuth] = transaction?.txnMetaData?.bill?.authenticators
          const prevAuths = transaction?.txnMetaData?.bill?.authenticators?.toString()
          id = prevFirstAuth === currentFirstAuth ? prevAuths : '9988'
        }
        const updatedTxn: any = {
          ...own.transaction,
          status: params?.status ?? transaction?.status,
          timeStamp: params?.timeStamp ?? transaction?.timeStamp,
          amount: params?.amount ?? transaction?.amount,
          txnMetaData: {
            ...transaction?.txnMetaData,
            id: params?.billerCategoryMasterId ?? transaction?.txnMetaData?.id,
            catId: params?.billerCategoryMasterId ?? transaction?.txnMetaData?.catId,
            myJioTxnNo: params?.myJioTxnNo ?? transaction?.txnMetaData?.myJioTxnNo,
            myJioUtrNo: params?.myJioUtrNo ?? transaction?.txnMetaData?.myJioUtrNo,
            errorMessage: params?.errorMessage ?? transaction?.txnMetaData?.errorMessage,
            bill: {
              ...transaction?.txnMetaData?.bill,
              id,
              amount: params?.amount ?? transaction?.txnMetaData?.bill?.amount,
              operatorId: params?.billerMasterId ?? transaction?.txnMetaData?.bill.operatorId,
              categoryId: params?.billerCategoryMasterId ?? transaction?.txnMetaData?.bill.categoryId,
              //authenticators: params?.authenticators ?? transaction?.txnMetaData?.bill.authenticators,
              shortName: params?.shortName ?? transaction?.txnMetaData?.bill.shortName,
              operatorName: params?.operatorName ?? transaction?.txnMetaData?.bill.operatorName,
              circleId: params?.circleId ?? transaction?.txnMetaData?.bill.circleId,
              circleName: params?.circleName ?? transaction?.txnMetaData?.bill.circleName,
              //labelOfAuthenticators:
              // params?.labelOfAuthenticators ?? transaction?.txnMetaData?.bill.labelOfAuthenticators,
            },
          },
        }

        if (params?.authenticators) {
          updatedTxn.txnMetaData.bill.authenticators = [...params.authenticators].slice()
        }

        if (params?.labelOfAuthenticators) {
          updatedTxn.txnMetaData.bill.labelOfAuthenticators = [...params.labelOfAuthenticators].slice()
        }
        own.transaction = updatedTxn
      } catch (error) {
        RootStore?.response?.setMessage(getBillPayErrorMessage(error)?.message)
        throw error
      }
    },
    getAllMyBillsList(): any {
      const bills = self.user?.bills ?? []
      const operators = self.operator

      const due = [] as Array<any>
      const scheduled = [] as Array<any>
      const recharges = [] as Array<any>
      const remaining = [] as Array<any>

      bills?.forEach((bill) => {
        const operator = operators.find((op: any) => op.id === bill?.operatorId || op.iDEBPP === bill?.operatorId)
        const billItem = {
          id: bill?.id,
          customerBillerAccountId: bill?.customerBillerAccountId ?? 0,
          billerMasterId: bill?.operatorId ?? 0,
          categoryId: bill?.categoryId ?? 0,
          billerShortName: operator?.shortName ?? '',
          authenticators: bill?.authenticators ?? [],
          labelOfAuthenticators: bill?.labelOfAuthenticators ?? [],
          shortName: bill?.shortName ?? '',
          title: `${bill?.shortName} - ${bill?.authenticators !== undefined ? bill?.authenticators[0] : ''}`,
          dateInfo: getDateInfo(bill),
          noteInfo: getNoticeInfo(bill),
          amount: bill?.amount ?? 0,
          imageUrl: operator?.logoPath ?? '',
          autoPayAllow: operator?.autoPayAllow ?? false,
          siStatus: bill?.siStatus,
          status: bill?.status,
          billDueDate: bill?.dueDate,
          isBbpsBiller: operator?.isBbps ?? false,
          type: bill?.type,
          lastTxnRefNo: bill?.lastTxnRefNo,
          circleName: bill?.circleName ?? '',
          circleId: bill?.circleId ?? 0,
        }
        if (bill?.type) {
          due.push(billItem)
        }
      })

      const dueTotalAmount = due.reduce((acc: any, bill: any) => {
        return acc + Number(bill?.amount)
      }, 0)

      const scheduledTotalAmount = scheduled.reduce((acc: any, bill: any) => {
        return acc + Number(bill?.amount)
      }, 0)

      const totalAmount = dueTotalAmount + scheduledTotalAmount

      const totalBills = due.length + scheduled.length

      const sectionData = []
      if (due.length > 0) {
        sectionData.push(
          {
            title: 'Due Bills',
            type: 'HEADER',
          },
          ...due,
        )
      }
      if (scheduled.length > 0) {
        sectionData.push(
          {
            title: 'Scheduled Bills',
            type: 'HEADER',
          },
          ...scheduled,
        )
      }
      if (recharges.length > 0) {
        sectionData.push(
          {
            title: 'Recharges',
            type: 'HEADER',
          },
          ...recharges,
        )
      }

      if (remaining.length > 0) {
        sectionData.push(
          {
            title: 'Remaining Bills',
            type: 'HEADER',
          },
          ...remaining,
        )
      }
      return { sectionData, totalAmount, totalBills, dueBills: due }
    },
    getBillFetchApi: flow(function* getBillFetchApi() {
      try {
        const own = self
        const transaction = own.transaction
        const merchantId = RootStore.user?.selectedMid
        const bill: any = own.transaction?.txnMetaData?.bill ?? {}
        const operatorId = bill.operatorId
        const operator = self.operator?.filter((txn: any) => txn.id === operatorId)[0]
        const values = {
          domain: {
            id: 'PayMyBill',
            name: 'PayMyBill',
            transactionType: 'BUY',
            description: 'This is for the buy case',
          },
          initiatingEntity: {
            entityId: Config.REACT_APP_CHANNEL_ID,
            // channelId: '1234',
          },
          product: {
            id: operatorId,
            attribute: {
              authenticatorList: bill?.authenticators ?? [],
            },
            displayName: bill?.shortName ?? '',
          },
          agent: {
            merchantId: merchantId,
          },
        }

        const billfetchResponse = yield getBillFetch(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          values,
        )
        const updatedTxn = {
          ...transaction,
          amount: billfetchResponse?.amount ?? transaction.amount,
          txnMetaData: {
            ...transaction.txnMetaData,
            bill: {
              ...transaction?.txnMetaData?.bill,
              ...billfetchResponse?.txnMetaData?.bill,
              operatorId: bill?.operatorId,
              //beneficiaryId: bill?.beneficiaryId,
            },
          },
        }

        own.transaction = updatedTxn
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    updateCategorySelection: (params: any) => {
      try {
        const own = self
        const transaction = own.transaction

        let txnMetaData = {
          ...transaction.txnMetaData,
        }
        if (params.status) {
          txnMetaData.status = params.status
        }
        if (params.catId) {
          const catId = Number(params.catId)
          const category = getCategoryMetaData(catId).title ?? ''
          txnMetaData.catId = catId
          txnMetaData.id = catId
          txnMetaData.category = category
        }

        const updateTransaction = {
          ...transaction,
          txnMetaData,
        }
        if (params.status) {
          updateTransaction.status = params.status
        }

        own.transaction = updateTransaction
      } catch (error) {
        RootStore?.response?.setMessage(getBillPayErrorMessage(error)?.message)
        throw error
      }
    },
    getOrderHistoryApi: flow(function* getOrederHistoryApi(
      startDate: string,
      endDate: string,
      abortController?: any,
      limit?: any,
      offset?: any,
      isLoadMore = false,
    ) {
      try {
        const jfsToken = RootStore.user.session.jfsUserId
        const response = yield getOrderHistory(
          jfsToken ?? '',
          startDate,
          endDate,
          limit,
          offset,
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          abortController,
        )

        if (!response?.message) {
          if (isLoadMore) {
            let oldOrders = JSON.parse(JSON.stringify(self?.orders))
            const orders = [...oldOrders, ...response]
            self.orders = JSON.parse(JSON.stringify(orders))
          } else {
            self.orders = JSON.parse(JSON.stringify(response))
          }
        }
        return response
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        // self.message.setMessage(message, MessageTypes.error, false)
        throw customError
      }
    }),
    searchByOrderIdApi: flow(function* searchByOrderIdApi(orderId: string, abortController?: any) {
      try {
        const jfsToken = RootStore.user.session.jfsUserId
        const response = yield searchByOrderId(
          jfsToken ?? '',
          orderId,
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          abortController,
        )

        if (!response?.message) {
          self.orders = JSON.parse(JSON.stringify(response))
        }
        return response
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        // self.message.setMessage(message, MessageTypes.error, false)
        throw customError
      }
    }),
    updateTransactionOrder: (params: any) => {
      try {
        const own = self
        const onGoingTxn = own.transaction
        const paymentStatus = params?.status
        const status: string = getStatusFromOrderApi(params) //statusMap.PENDING
        const metaData = params?.product?.metaData?.bpAuthenticator
        const billMetaDate = returnExtraInfo(metaData, params.payment?.id)
        let paymentExtraInfo = []
        try {
          if (params?.hasOwnProperty('status')) {
            paymentExtraInfo = returnExtraInfo(
              [
                { name: 'Debited From', value: params?.payment?.account?.bankName },
                { name: 'Product Name', value: params?.product?.name },
                { name: 'Payment Mode', value: params?.payment?.paymentInstrument },
                { name: 'Transaction ID', value: params?.payment?.paymentProcessorRefNo },
              ],
              params?.payment?.id,
            )
          }
        } catch (error) {
          console.log('extra info parsing error', error)
        }
        const extraInfos = [...billMetaDate, ...paymentExtraInfo]
        const txn = {
          status: status ?? 'FAILED',
          timeStamp: params.timeStamp ?? simpleDateFormat(new Date(), 'yyyy-MM-ddTHH:mm:ss'),
          txnId: params?.payment?.id,
          txnMetaData: {
            bbpsRefNo: params?.product?.bbpsRegNo ?? '',
            errorMessage: params?.errorMessage ?? '',
            billConfirmationNumber: params?.product?.metaData?.bpAuthenticator?.[0]?.value,
            bill: {
              extraInfos: extraInfos,
              authenticators: params?.product?.attribute?.authenticatorList,
              beneficiaryId: params?.beneficiary?.id,
            },
          },
        }

        const updatedTxn: any = {
          ...onGoingTxn,
          ...txn,
          orderId: params.id,
          amount: params?.payment?.amountDetails?.netAmount,
          status,
          txnMetaData: {
            ...onGoingTxn?.txnMetaData,
            ...txn?.txnMetaData,
            bill: {
              ...onGoingTxn?.txnMetaData?.bill,
              ...txn?.txnMetaData.bill,
              extraInfos: [...extraInfos],
            },
          },
        }

        const data: any = { ...onGoingTxn, ...updatedTxn }
        own.transaction = data
        //console.log('test transactionstatus before update', status, { data })
        return data
      } catch (error) {
        RootStore?.response?.setMessage(getBillPayErrorMessage(error)?.message)
        throw error
      }
    },
    searchAgent: flow(function* searchAgentByMid() {
      try {
        const response = yield searchAgent(
          RootStore.user?.session?.getTokens,
          RootStore.user?.session?.userAccessToken,
          RootStore.user?.selectedMid,
        )
        return response
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        //RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    getOperatorList(categoryId: any) {
      const catId = categoryId ?? self.transaction.txnMetaData.catId
      const operatordata = self.operator.filter((item: any) => item.categoryId === catId)
      const retData = operatordata.map((item: any) => {
        return {
          title: item?.shortName ?? '',
          imageURL: item?.logoPath ?? '',
          id: item?.id ?? '',
          searchTags: item?.searchTags ?? '',
          categoryId: item?.categoryId ?? 0,
          type: 'OPERATORITEM',
        }
      })
      return retData
    },
    getRecentData(): any {
      const own = self
      const catId = own.transaction.txnMetaData.catId
      const favData = self.user.favourites.filter((item: any) => item.categoryId === catId)
      const recentData = favData.map((bill: any) => {
        const operator = self.operator.find((opItem: any) => opItem.id === bill?.operatorId)
        return {
          title: bill?.billerShortName ?? '',
          subTitle: bill?.shortName && `${bill?.shortName} | ${bill?.authenticators[0]}`,
          imageURL: operator?.logoPath ?? '',
          id: operator?.id ?? 0,
          authenticators: JSON.parse(JSON.stringify(bill?.authenticators)), //FAULTY
          shortName: bill?.shortName,
          billPresentConsent: bill?.billPresentConsent ?? false,
          billPresentConsentDisplay: bill?.billPresentConsentDisplay ?? false,
          customerBillerAccountId: bill?.customerBillerAccountId ?? 0,
          type: 'RECENTITEM',
          circleId: bill?.circleId,
          circleName: bill?.circleName,
        }
      })
      return recentData
    },
    getOperatorListApi: flow(function* getOperatorListApi(categoryId: number) {
      try {
        const own = self
        const catId = categoryId ?? own.transaction.txnMetaData.catId
        const operatorId = own.transaction.txnMetaData.bill.operatorId
        const OperatorResponse = yield getOperatorList(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          catId,
        )

        const recentBills = yield getFavouriteTransaction(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          catId,
          operatorId,
        )

        const otherFavourites = own.user.favourites.filter((item: any) => item.categoryId !== catId)
        const otherOperator = own.operator.filter((item: any) => item.categoryId !== catId)
        const updatedProd: any = [...otherFavourites, ...recentBills]
        const operatorsResponse: any = [...otherOperator, ...OperatorResponse]
        own.operator = operatorsResponse
        own.user.favourites = updatedProd
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        // RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    getAuthenticatorListApi: flow(function* getAuthenticatorListApi(billerMasterId: number) {
      try {
        const own = self
        const response = yield getAuthenticatorList(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          billerMasterId,
        )
        const currentProductIndex = own.operator.findIndex((item: any) => item.id === billerMasterId)
        const currentProduct = own.operator[currentProductIndex]
        const earlierProducts = own.operator.slice(0, currentProductIndex)
        const laterProducts = own.operator.slice(currentProductIndex + 1)
        const updatedProd = {
          ...currentProduct,
          distributor: [],
          fields: response.fieldData,
          nickNameField: response.nickNamefield,
        }
        const data: any = [...earlierProducts, updatedProd, ...laterProducts]
        own.operator = data
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    getOperator(): any {
      const operatorId = self.transaction.txnMetaData.bill.operatorId
      const retData = self.operator?.filter((txn: any) => txn.id === operatorId)[0]
      console.log(
        'getOperator retData',
        JSON.parse(JSON.stringify(self.transaction)),
        JSON.parse(JSON.stringify(self.operator)),
      )
      return retData
    },
    registerBillerApi: flow(function* registerBillerApi(masterBillerId: number) {
      try {
        const own = self
        const transaction = own.transaction
        const bill: any = own.transaction?.txnMetaData?.bill ?? {}

        const values = {
          billerMasterId: bill?.operatorId,
          authenticators: bill?.authenticators ?? [],
          shortName: bill?.shortName ?? '',
          siStatus: bill?.siStatus ? 'Y' : 'N',
          siMaxLimit: bill?.siMaxLimit ?? 'NA',
          payDaysBefore: bill?.payDaysBefore,
        }
        const apiResponse = yield registerBillerAPI(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          values,
        )

        const newBill = { ...transaction?.txnMetaData?.bill, ...apiResponse }
        const updatedTxn = {
          ...transaction,
          status: TransactionStatus.REGISTERED_BILLER,
          timeStamp: simpleDateFormat(new Date(), 'yyyy-MM-ddTHH:mm:ss'),
          txnMetaData: {
            ...transaction.txnMetaData,
            bill: newBill,
          },
        }
        own.transaction = updatedTxn
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    createOrderApi: flow(function* createOrderApi(payAmount: any, form: any) {
      try {
        const own = self
        const bill = own.transaction?.txnMetaData?.bill
        //console.log('createOrderApi bill', JSON.parse(JSON.stringify(bill)))

        const values: any = {
          billAmount: bill?.amount,
          payAmount,
          billerMasterId: bill?.operatorId ?? 0,
          authenticators: bill?.authenticators ?? [],
          beneficiaryId: bill?.beneficiaryId ?? 0,
          ebppBillerMasterId: bill?.ebppBillerMasterId,
          customerBillDataId: bill?.customerBillDataId ?? 0,
          customerBillerAccountId: bill?.customerBillerAccountId ?? 0,
          shortName: bill?.shortName ?? '',
          billNumber: bill?.billNumber ? bill?.billNumber : 'NA',
          billDate: bill?.date ? bill?.date : 'NA',
          billDueDate: bill?.dueDate ? bill?.dueDate : 'NA',
          debitType: '3152',
          customerMobileNumber: self.user.mobile,
          customerAccountId: bill?.customerAccountId ?? 0,
          customerEmail: self.user.email,
          agentFeeAmount: bill.agentFeeAmount,
        }

        const merchantId = RootStore.user?.selectedMid
        const req = {
          ...form,
          merchantId: merchantId,
          name: self.user.firstName + self.user.lastName,
        }

        const result = yield createOrder(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          values,
          req,
        )

        const { response, pgMetaData }: any = result ?? {}
        const { appIdToken, intent, appAccessToken } = pgMetaData ?? {}

        // TODO: if token is not present in the create order request
        if (!intent || !appIdToken || !appAccessToken) {
          const customError = {
            message: ErrorMessage.ERROR_PROCESSING_REQUEST,
            code: ErrorState.FAILED,
          }
          RootStore?.response?.setMessage(customError?.message)
          throw customError
        }

        const txnRefNo = response.txnRefNo
        const transaction = own.transaction
        const txnMetaData = {
          txnRefNo,
          bill: {
            ...transaction.txnMetaData.bill,
            customerBillerAccountId: response?.customerBillerAccountId ? Number(response?.customerBillerAccountId) : 0,
            partnerCode: response.partnerCode,
            customerMobileNumber: form.mobileNumber,
            customerModeOfPayment: form.modeOfPayment,
          },
          myjioToken: response?.myjioToken,
          merchant: response?.merchant,
          orderId: response?.orderId,
          pgToken: response?.intentId,
          pgUrl: response?.returnUrl,
        }

        const updatedTxn = {
          ...transaction,
          txnId: response.txnRefNo,
          orderId: response?.orderId,
          amount: response?.paymentAmount ?? transaction?.amount,
          txnMetaData: {
            ...transaction?.txnMetaData,
            ...txnMetaData,
          },
        }

        own.transaction = updatedTxn
        return result
      } catch (error) {
        console.log('create order error', error)
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    checkPaymentStatusApi: flow(function* checkPaymentStatusApi(orderId: any) {
      const own = self
      const onGoingTxn = own.transaction
      const bbpsRef = onGoingTxn?.txnMetaData.bbpsRefNo
      const [mockStatus] = onGoingTxn?.status?.split('_')
      // get the values from store instead
      // const localOrderData = window?.localStorage?.getItem('orderData')

      // let parsedOrderData: any
      // if (localOrderData && localOrderData !== null) {
      //   parsedOrderData = JSON.parse(localOrderData)
      // }

      try {
        const response = yield checkPaymentStatus(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          orderId ? orderId : onGoingTxn?.txnMetaData?.orderId,
        )
        const txnStatus = response?.txn?.status
        const status = bbpsRef === 'MOCK' ? mockStatus : txnStatus
        const extraInfos = response?.txn?.txnMetaData?.bill?.extraInfos ?? []
        const updatedTxn: any = {
          ...onGoingTxn,
          ...response?.txn,
          orderId: String(orderId ?? 0),
          amount: onGoingTxn?.amount,
          status,
          txnMetaData: {
            ...onGoingTxn?.txnMetaData,
            ...response?.txn?.txnMetaData,
            bill: {
              ...onGoingTxn?.txnMetaData?.bill,
              ...response?.txn?.txnMetaData.bill,
              extraInfos: [...extraInfos],
            },
          },
        }

        const data: any = { ...onGoingTxn, ...updatedTxn }
        own.transaction = data
        return response.res
      } catch (error) {
        let trxStatus = 'FAILURE'
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
          errorCode: error?.errorCode,
          status: error?.status ?? trxStatus,
        }
        const updatedTxn: any = {
          ...onGoingTxn,
          orderId: String(orderId ?? 0),
          timeStamp: simpleDateFormat(new Date(), 'yyyy-MM-ddTHH:mm:ss'),
          amount: onGoingTxn?.amount,
          status: error?.status ?? '',
          txnMetaData: {
            ...onGoingTxn?.txnMetaData,
            bill: {
              ...onGoingTxn?.txnMetaData?.bill,
            },
          },
        }
        const data: any = { ...onGoingTxn, ...updatedTxn }
        own.transaction = data
        //RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    redirectToPg: flow(function* redirectToPg(pgMetaData) {
      try {
        const REACT_APP_ENV = Config.REACT_APP_ENV
        const buildVariant = REACT_APP_ENV.toLowerCase()
        const pgData = {
          appaccesstoken: pgMetaData?.appAccessToken,
          appidtoken: pgMetaData?.appIdToken,
          intentid: pgMetaData?.intent,
          theme: {
            brandColor: Colors.PRIMARY,
            //headingText: Colors.WHITE,
          },
          checkout: {
            template: {
              id: '101',
            },
          },
          buildVariant,
        }
        const data = yield redirectPgFn(pgData)
        return data
      } catch (error) {
        RootStore?.response?.setMessage(error?.message)
        throw error
      }
    }),

    getLocationListApi: flow(function* getLocationListApi() {
      try {
        const own = self
        const catId = own.transaction.txnMetaData.catId
        const locationInfo = yield getLocationList(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          catId,
        )
        // console.log('locationInfo', locationInfo)

        const trxObj: any = { ...own.transaction, locationInfo }
        // console.log('locationInfo merged', locationInfo)
        own.transaction = trxObj

        return locationInfo
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    updateIntituteLocationInfo: (params: any) => {
      try {
        const own = self
        const transaction = own.transaction
        const selectedLocation = {
          state: params?.state,
          city: params?.city,
        }
        const updatedTxn = {
          ...transaction,
          locationInfo: { ...transaction.locationInfo, selectedLocation: selectedLocation },
        }

        own.transaction = updatedTxn
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        RootStore?.response?.setMessage(message)
        throw customError
      }
    },
    seachBillersApi: flow(function* seachBillersApi(searchText: string, pageNo: number, clearCache: boolean) {
      try {
        const own = self
        own.transaction.currentNewsPageStarted = pageNo
        const locationInfo: any = self.transaction.locationInfo.selectedLocation
        const filter = { State: locationInfo.state, City: locationInfo.city }
        const response = yield seachBillers(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          filter,
          searchText,
          pageNo,
        )
        const otherOperator = clearCache ? [] : self.operator
        const operatorsResponse: any = [...otherOperator, ...response]
        own.operator = operatorsResponse
        own.transaction.currentNewsPageFetched = pageNo
        return response
      } catch (error) {
        const { message, code } = getBillPayErrorMessage(error)
        const customError = {
          message,
          code,
        }
        RootStore?.response?.setMessage(message)
        throw customError
      }
    }),
    loadMoreTransactions(getOrderHistoryApi: any, dateObj = self.selectedDateInfo, offset: any, abortController: any) {
      const fromDate = hyphenSplashSeparatedDate(new Date(dateObj.fromDate), 'yyyy-MM-dd hh:mm:ss').replace(' ', 'T')
      const toDate = hyphenSplashSeparatedDate(new Date(dateObj.toDate), 'yyyy-MM-dd hh:mm:ss').replace(' ', 'T')

      const data = getOrderHistoryApi(fromDate, toDate, abortController, 10, offset, true)
      return data
    },
    updateAllFilters(newSettings: any): void {
      const own = self
      own.filter.selectedDateInfo = newSettings?.selectedDateInfo ?? {}
      own.filter.email = newSettings?.email ?? ''
      own.filter.mobile = newSettings?.mobile ?? ''
      own.filter.amount = newSettings?.amount ?? ''
      own.filter.invoiceNo = newSettings?.invoiceNo ?? ''
    },
    updateSelectedFilterDateInfo(dateObj: any): void {
      self.filter.selectedDateInfo.fromDate = dateObj?.fromDate ?? null
      self.filter.selectedDateInfo.toDate = dateObj?.toDate ?? null
      self.filter.selectedDateInfo.dateLabel = dateObj?.dateLabel ?? ''
    },
    updateSelectedDateInfo(dateObj?: any): void {
      const own = self
      const lastSevenDays = getSelectedDate(INFINITE_SCROLL_WINDOW_INDEX)
      own.selectedDateInfo.fromDate = dateObj?.fromDate ?? lastSevenDays
      own.selectedDateInfo.toDate = dateObj?.toDate ?? new Date(Date.now())
      own.selectedDateInfo.dateLabel = dateObj?.dateLabel ?? 'infinite scroll'
    },
    resetFilters(): void {
      const own = self
      RootStore.billPayments.updateSelectedDateInfo(null)
      const defaultFilters = {
        selectedDateInfo: defaultSelectedFilters.selectedDateInfo,
      }
      own.orders = JSON.parse(JSON.stringify([]))
      own.filter = JSON.parse(JSON.stringify(defaultFilters))
    },
    clearOrder() {
      const own = self
      own.orders = JSON.parse(JSON.stringify([]))
    },
  }))
  .views((self) => ({
    getCategoryBySearchText(list: any, searchText: string): any {
      const filteredList = []
      list?.map((item: any) => {
        const filtered = item?.categoryList?.filter((cat: any) => cat?.name?.toLowerCase()?.includes(searchText))
        if (filtered?.length) {
          filteredList.push({ ...item, categoryList: filtered })
        }
      })
      return filteredList ?? []
    },
    getBill(): any {
      return self.transaction.txnMetaData.bill
    },
    getOperator(): any {
      const operatorId = self.transaction.txnMetaData.bill.operatorId
      const retData = self.operator?.filter((txn: any) => txn.id === operatorId)[0]
      // console.log(
      //   'getOperator retData',
      //   JSON.parse(JSON.stringify(self.transaction)),
      //   JSON.parse(JSON.stringify(self.operator)),
      // )
      return retData
    },
  }))

const defaultSelectedFilters = {
  mobile: '',
  amount: '',
  invoiceNo: '',
  email: '',
  paymentLinkStatus: '',
  selectedDateInfo: {
    fromDate: null,
    toDate: null,
    dateLabel: '',
  },
}

const BillPaymentsData = BillPayments.create({
  user: {},
  operator: [],
  transaction: {},
  orders: [],
  selectedDateInfo: {
    fromDate: getSelectedDate(INFINITE_SCROLL_WINDOW_INDEX),
    toDate: new Date(Date.now()),
    dateLabel: 'infinite scroll',
  },
  filter: defaultSelectedFilters,
})

export { BillPayments, BillPaymentsData }
